const OBJECT_ID_NULO = '000000000000000000000000'

// O backend Go serializa ObjectIDs não preenchidos (primitive.NilObjectID)
// como "000000000000000000000000", que é truthy em JS.
export function isObjectIdValido(id) {
  return typeof id === 'string' && id !== '' && id !== OBJECT_ID_NULO
}
